var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame",class:_vm.color},_vm._l((_vm.arrayOfNumbers),function(number,key){return _c('KZNumber',{key:key,attrs:{"number":number}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }